"use strict";

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(zip);

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/** zip two arrays, return an iterator */

function zip(a, b) {
  var i;
  return _regeneratorRuntime.wrap(function zip$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          i = 0;

        case 1:
          if (!(i < a.length)) {
            _context.next = 7;
            break;
          }

          _context.next = 4;
          return [a[i], b[i]];

        case 4:
          i++;
          _context.next = 1;
          break;

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.zip = zip;
/** zip two arrays, return a new array */

function zipArray(a, b) {
  if (a.length < b.length) {
    return a.map(function (elem, idx) {
      return [elem, b[idx]];
    });
  } else {
    return b.map(function (elem, idx) {
      return [a[idx], elem];
    });
  }
}

exports.zipArray = zipArray;
/** Transpose a matrix r[i][j] = matrix[j][i] */

function transpose(matrix) {
  if (matrix == undefined) {
    return undefined;
  }

  if (matrix.length == 0) {
    return [];
  }

  var jLength = matrix[0].length;
  var r = [];

  for (var j = 0; j < jLength; j++) {
    var rj = [];

    for (var _i = 0; _i < matrix.length; _i++) {
      rj.push(matrix[_i][j]);
    }

    r.push(rj);
  }

  return r;
}

exports.transpose = transpose;
/** Generate a range of integers: [start, end) */

function makeRange(start, end) {
  var r = [];

  for (var _i2 = start; _i2 < end; _i2++) {
    r.push(_i2);
  }

  return r;
}

exports.makeRange = makeRange;
/** Deep clone an object. The object must be JSON-serializable */

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

exports.deepClone = deepClone;

function shallowClone(obj) {
  var r = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      r[key] = obj[key];
    }
  }

  return r;
}

exports.shallowClone = shallowClone;

function max(array, accessor) {
  // Credit: https://github.com/d3/d3-array/blob/master/src/max.js
  var i = -1;
  var n = array.length;
  var value;
  var max;

  while (++i < n) {
    if ((value = accessor(array[i], i, array)) != null && value >= value) {
      max = value;

      while (++i < n) {
        if ((value = accessor(array[i], i, array)) != null && value > max) {
          max = value;
        }
      }
    }
  }

  return max;
}

exports.max = max;

function argMax(array, accessor) {
  var i = -1;
  var n = array.length;
  var value;
  var max;
  var argmax = -1;

  while (++i < n) {
    if ((value = accessor(array[i], i, array)) != null && value >= value) {
      max = value;
      argmax = i;

      while (++i < n) {
        if ((value = accessor(array[i], i, array)) != null && value > max) {
          max = value;
          argmax = i;
        }
      }
    }
  }

  return argmax;
}

exports.argMax = argMax;

function min(array, accessor) {
  // Credit: https://github.com/d3/d3-array/blob/master/src/min.js
  var i = -1;
  var n = array.length;
  var value;
  var min;

  while (++i < n) {
    if ((value = accessor(array[i], i, array)) != null && value >= value) {
      min = value;

      while (++i < n) {
        if ((value = accessor(array[i], i, array)) != null && min > value) {
          min = value;
        }
      }
    }
  }

  return min;
}

exports.min = min;

function argMin(array, accessor) {
  var i = -1;
  var n = array.length;
  var value;
  var min;
  var argmin;

  while (++i < n) {
    if ((value = accessor(array[i], i, array)) != null && value >= value) {
      min = value;
      argmin = i;

      while (++i < n) {
        if ((value = accessor(array[i], i, array)) != null && min > value) {
          min = value;
          argmin = i;
        }
      }
    }
  }

  return argmin;
}

exports.argMin = argMin;

function setField(obj, field, value) {
  var p = obj;

  if (typeof field == "string" || typeof field == "number") {
    p[field] = value;
  } else {
    for (var _i3 = 0; _i3 < field.length - 1; _i3++) {
      if (p[field[_i3]] == undefined) {
        p[field[_i3]] = {};
      }

      p = p[field[_i3]];
    }

    p[field[field.length - 1]] = value;
  }

  return obj;
}

exports.setField = setField;

function getField(obj, field) {
  var p = obj;

  if (typeof field == "string" || typeof field == "number") {
    return p[field];
  } else {
    var fieldList = field;

    for (var _i4 = 0; _i4 < fieldList.length - 1; _i4++) {
      if (p[fieldList[_i4]] == undefined) {
        return undefined;
      }

      p = p[fieldList[_i4]];
    }

    return p[fieldList[fieldList.length - 1]];
  }
}

exports.getField = getField;
/** Fill default values into an object */

function fillDefaults(obj, defaults) {
  if (obj == null) {
    obj = {};
  }

  for (var key in defaults) {
    if (defaults.hasOwnProperty(key)) {
      if (!obj.hasOwnProperty(key)) {
        obj[key] = defaults[key];
      }
    }
  }

  return obj;
}

exports.fillDefaults = fillDefaults;
/** Find the index of the first element that satisfies the predicate, return -1 if not found */

function indexOf(array, predicate) {
  for (var _i5 = 0; _i5 < array.length; _i5++) {
    if (predicate(array[_i5], _i5)) {
      return _i5;
    }
  }

  return -1;
}

exports.indexOf = indexOf;
/** Get the first element with element._id == id, return null if not found */

function getById(array, id) {
  for (var _i6 = 0; _i6 < array.length; _i6++) {
    if (array[_i6]._id == id) {
      return array[_i6];
    }
  }

  return null;
}

exports.getById = getById;
/** Get the index of the first element with element._id == id, return -1 if not found */

function getIndexById(array, id) {
  for (var _i7 = 0; _i7 < array.length; _i7++) {
    if (array[_i7]._id == id) {
      return _i7;
    }
  }

  return -1;
}

exports.getIndexById = getIndexById;
/** Get the first element with element.name == name, return null if not found */

function getByName(array, name) {
  for (var _i8 = 0; _i8 < array.length; _i8++) {
    if (array[_i8].name == name) {
      return array[_i8];
    }
  }

  return null;
}

exports.getByName = getByName;
/** Get the index of the first element with element.name == name, return -1 if not found */

function getIndexByName(array, name) {
  for (var _i9 = 0; _i9 < array.length; _i9++) {
    if (array[_i9].name == name) {
      return _i9;
    }
  }

  return -1;
}

exports.getIndexByName = getIndexByName;

function gather(array, keyFunction) {
  var map = new Map();
  array.forEach(function (item, index) {
    var key = keyFunction(item, index);

    if (map.has(key)) {
      map.get(key).push(item);
    } else {
      map.set(key, [item]);
    }
  });
  var r = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = map.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _array = _step.value;
      r.push(_array);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return r;
}

exports.gather = gather;
/**
 * Sort an array with compare function, make sure when compare(a, b) == 0,
 * a and b are still in the original order (i.e., stable)
 */

function stableSort(array, compare) {
  return array // Convert to [ item, index ]
  .map(function (x, index) {
    return [x, index];
  }) // Sort by compare then by index to stabilize
  .sort(function (a, b) {
    var c = compare(a[0], b[0]);

    if (c != 0) {
      return c;
    } else {
      return a[1] - b[1];
    }
  }) // Extract items back
  .map(function (x) {
    return x[0];
  });
}

exports.stableSort = stableSort;
/** Sort an array by key given by keyFunction */

function sortBy(array, keyFunction) {
  var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (reverse) {
    return array.sort(function (a, b) {
      var ka = keyFunction(a);
      var kb = keyFunction(b);

      if (ka == kb) {
        return 0;
      }

      return ka < kb ? +1 : -1;
    });
  } else {
    return array.sort(function (a, b) {
      var ka = keyFunction(a);
      var kb = keyFunction(b);

      if (ka == kb) {
        return 0;
      }

      return ka < kb ? -1 : +1;
    });
  }
}

exports.sortBy = sortBy;
/** Stable sort an array by key given by keyFunction */

function stableSortBy(array, keyFunction) {
  var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (reverse) {
    return stableSort(array, function (a, b) {
      var ka = keyFunction(a);
      var kb = keyFunction(b);

      if (ka == kb) {
        return 0;
      }

      return ka < kb ? +1 : -1;
    });
  } else {
    return stableSort(array, function (a, b) {
      var ka = keyFunction(a);
      var kb = keyFunction(b);

      if (ka == kb) {
        return 0;
      }

      return ka < kb ? -1 : +1;
    });
  }
}

exports.stableSortBy = stableSortBy;
/** Map object that maps (Object, string) into ValueType */

var KeyNameMap =
/*#__PURE__*/
function () {
  function KeyNameMap() {
    _classCallCheck(this, KeyNameMap);

    this.mapping = new Map();
  }
  /** Add a new entry to the map */


  _createClass(KeyNameMap, [{
    key: "add",
    value: function add(key, name, value) {
      if (this.mapping.has(key)) {
        this.mapping.get(key)[name] = value;
      } else {
        var item = {};
        item[name] = value;
        this.mapping.set(key, item);
      }
    }
    /** Delete an entry (do nothing if not exist) */

  }, {
    key: "delete",
    value: function _delete(key, name) {
      if (this.mapping.has(key)) {
        delete this.mapping.get(key)[name];
      }
    }
    /** Determine if the map has an entry */

  }, {
    key: "has",
    value: function has(key, name) {
      if (this.mapping.has(key)) {
        return this.mapping.get(key).hasOwnProperty(name);
      }

      return false;
    }
    /** Get the value corresponding to an entry, return null if not found */

  }, {
    key: "get",
    value: function get(key, name) {
      if (this.mapping.has(key)) {
        var m = this.mapping.get(key);

        if (m.hasOwnProperty(name)) {
          return m[name];
        }

        return null;
      }

      return null;
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      this.mapping.forEach(function (v, key) {
        for (var p in v) {
          if (v.hasOwnProperty(p)) {
            callback(v[p], key, p);
          }
        }
      });
    }
  }]);

  return KeyNameMap;
}();

exports.KeyNameMap = KeyNameMap;

var HashMap =
/*#__PURE__*/
function () {
  function HashMap() {
    _classCallCheck(this, HashMap);

    this.map = new Map();
  }

  _createClass(HashMap, [{
    key: "set",
    value: function set(key, value) {
      this.map.set(this.hash(key), value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.map.get(this.hash(key));
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.map.has(this.hash(key));
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.map.delete(this.hash(key));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: "values",
    value: function values() {
      return this.map.values();
    }
  }]);

  return HashMap;
}();

exports.HashMap = HashMap;

var MultistringHashMap =
/*#__PURE__*/
function (_HashMap) {
  _inherits(MultistringHashMap, _HashMap);

  function MultistringHashMap() {
    var _this;

    _classCallCheck(this, MultistringHashMap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultistringHashMap).apply(this, arguments));
    _this.separator = Math.random().toString(36).substr(2);
    return _this;
  }

  _createClass(MultistringHashMap, [{
    key: "hash",
    value: function hash(key) {
      return key.join(this.separator);
    }
  }]);

  return MultistringHashMap;
}(HashMap);

exports.MultistringHashMap = MultistringHashMap;
/** Parse semver version string into a ParsedVersion */

function parseVersion(version) {
  var m = version.match(/^(\d+)\.(\d+)\.(\d+)$/);
  return {
    major: +m[1],
    minor: +m[2],
    patch: +m[3]
  };
}

exports.parseVersion = parseVersion;
/**
 * Compare two version strings
 * @param version1 version number 1
 * @param version2 version number 2
 * @returns negative if version1 < version2, zero if version1 == version2, positive if version1 > version2
 */

function compareVersion(version1, version2) {
  var p1 = parseVersion(version1);
  var p2 = parseVersion(version2); // Compare major version first, then minor and patch.

  if (p1.major != p2.major) {
    return p1.major - p2.major;
  }

  if (p1.minor != p2.minor) {
    return p1.minor - p2.minor;
  }

  return p1.patch - p2.patch;
}

exports.compareVersion = compareVersion;